import React, { useCallback } from 'react';

import { AccountManager, getActiveForms, NotificationManager } from '@atlas/core';
import { on2FaSignInSubmit, useActiveForm } from '@atlas/react-forms';
import { HeaderTitle, Icon } from '@atlas/ui';

import FormMobile from 'common/Form/FormMobile';
import { NotificationEmitterBasePopup } from 'common/Popup/NotificationEmitterBasePopup';

const TwoFactorLogin = ({ data, id }) => {
  const { activeStep, activeType, submit } = useActiveForm(
    'LOGIN_2FA_BY_PHONE',
    on2FaSignInSubmit(AccountManager.login2FaWithForm.bind(AccountManager)),
    getActiveForms,
  );

  const handleClose = useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  const submitHandler = useCallback(() => {
    handleClose();
    data.onClose();
  }, []);

  const renderForm = activeType ? (
    <FormMobile
      action={submit}
      additionalValues={{ sessionToken: data.sessionToken }}
      buttonText="sign_in"
      form={{ fields: activeType?.steps[0]?.fields, number: activeStep }}
      id={activeType.id}
      onSubmit={submitHandler}
      validateRequestHeaders={{ 'Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone }}
    />
  ) : null;

  return (
    <NotificationEmitterBasePopup className="two-factor-modal">
      <div className="popup__header">
        <HeaderTitle className="center border block-lg size-xl" title="two_factor_authentication">
          <div className="header-title__children">
            <button onClick={handleClose} type="button">
              <Icon name="close" />
            </button>
          </div>
        </HeaderTitle>
      </div>

      <div className="popup__content">{renderForm}</div>
    </NotificationEmitterBasePopup>
  );
};

export default TwoFactorLogin;
